/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { CloseIcon } from '../../assets/icons/CloseIcon'
import { ToastTypes, TOAST_TYPE_DEFAULT } from '../../libraries/Toast'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import IconButton from '../iconButton/IconButton'
import './Toast.scss'
const rootClassName = 'component-toast'

var timer: number
export interface ToastProps {
  id?: string
  label?: string
  theme?: ToastTypes
  timeout?: number
  showActionButton?: boolean
  actionButtonText?: string
  pauseOnFocusLoss?: boolean
  onActionButtonClick?: (evt?: any) => void
  showStatusBar?: boolean
  onClose?: () => void
  prevent?: boolean
}
export default function Toast(props: ToastProps) {
  const [id] = useState<string>(props.id || getUniqueKey())
  const getClassNames = () => {
    return getMergedClassNames([
      rootClassName,
      `${rootClassName}-${props.theme}`
    ])
  }

  useEffect(() => {
    const el = document.querySelector(
      `#${id} .${rootClassName}-fill`
    ) as HTMLElement
    if (props.showStatusBar && el) {
      el.style.animation = `fillToZero ${props.timeout}ms linear forwards`
    } else if (props.timeout) {
      setTimeout(() => {
        if (typeof props.onClose === 'function') props.onClose()
      }, props.timeout)
    }
    if (timer) {
      clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    const setPaused = (paused = false) => {
      const el = document.querySelector(
        `#${id} .component-toast-fill`
      ) as HTMLElement
      if (el) {
        el.style.animationPlayState = paused ? 'paused' : ''
      }
    }
    const setPause = () => setPaused(true)
    const setContinue = () => setPaused(false)

    if (props.pauseOnFocusLoss) {
      window.addEventListener('focus', setContinue)
      window.addEventListener('blur', setPause)
    }

    return () => {
      if (props.pauseOnFocusLoss) {
        window.removeEventListener('focus', setContinue)
        window.removeEventListener('blur', setPause)
      }
    }
  }, [])

  return (
    <div id={id} className={getClassNames()}>
      <div className={`${rootClassName}-left-content`}>{props.label}</div>
      <div className={`${rootClassName}-right-content`}>
        {props.showActionButton && (
          <div className={`${rootClassName}-action-button`}>
            {props.actionButtonText}
          </div>
        )}
        <div className={`${rootClassName}-close-button`}>
          <IconButton
            icon={<CloseIcon />}
            onClick={() => {
              if (typeof props.onClose === 'function') props.onClose()
            }}
          />
        </div>
      </div>
      {props.timeout && props.showStatusBar ? (
        <div className={`${rootClassName}-bar`}>
          <div
            className={`${rootClassName}-fill`}
            onAnimationEnd={() => {
              if (typeof props.onClose === 'function' && props.showStatusBar)
                props.onClose()
            }}
          />
        </div>
      ) : undefined}
    </div>
  )
}

Toast.defaultProps = {
  showStatusBar: false,
  theme: TOAST_TYPE_DEFAULT,
  showActionButton: false,
  actionButtonText: '',
  onActionButtonClick: () => {},
  onClose: () => {}
}
